import { render, staticRenderFns } from "./RestrictedInput.vue?vue&type=template&id=35b2e70c&scoped=true"
import script from "./RestrictedInput.vue?vue&type=script&lang=js"
export * from "./RestrictedInput.vue?vue&type=script&lang=js"
import style0 from "./RestrictedInput.vue?vue&type=style&index=0&id=35b2e70c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b2e70c",
  null
  
)

export default component.exports